<template>
  <settings-modal class="t-payment-comment-update-modal">
    <template slot="heading">Edit comment</template>

    <v-text-field
      v-model="form.comment"
      label="Comment"
      persistent-hint
      :maxlength="commentLength"
      :counter="commentLength"
      :error-messages="getValidationErrorMessage('comment')"
    />

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        color="light-blue darken-3"
        class="t-confirm-button"
        flat
        :disabled="loading"
        @click="onBlockButtonClick"
      >confirm</v-btn>

      <v-btn
        color="light-blue darken-3"
        class="t-cancel-button"
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentCommentUpdateModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        updateCommentByAccountant: new ApiRequest(PaymentApi.updateCommentByAccountant),
        form: { comment: null },
        requiredFields: ['comment']
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      currentComment () {
        return this.modal.data.comment
      },
      paymentId () {
        return this.modal.data.paymentId
      },
      commentLength () {
        return this.modal.data.commentLength
      },
      loading () {
        return this.updateCommentByAccountant.loading
      },
      error () {
        return this.updateCommentByAccountant.error
      }
    },
    created () {
      this.initFormData()
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      initFormData () {
        this.form.comment = this.currentComment
      },
      onBlockButtonClick () {
        this.updateCommentByAccountant
          .execute(this.paymentId, this.form.comment)
          .then(this.paymentCommentUpdateSuccessHandler)
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      paymentCommentUpdateSuccessHandler () {
        this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Payment comment has been successfully updated.' }
          })
        }, 100)
      }
    }
  }
</script>
